<span [ngClass]="{ '-sh-disabled': cell.disabled }">
    @if (cell.value === null) {
        -
    } @else {
        <svg sh-icon [name]="icon" [size]="'small'" aria-hidden="true"></svg>
    }
</span>
